export const COUNTRIES = [
   { name: "Afghanistan", iso2: "AF", flag: "/flags/AF.png" },
   { name: "Albania", iso2: "AL", flag: "/flags/AL.png" },
   { name: "Algeria", iso2: "DZ", flag: "/flags/DZ.png" },
   { name: "Andorra", iso2: "AD", flag: "/flags/AD.png" },
   { name: "Angola", iso2: "AO", flag: "/flags/AO.png" },
   { name: "Antigua and Barbuda", iso2: "AG", flag: "/flags/AG.png" },
   { name: "Argentina", iso2: "AR", flag: "/flags/AR.png" },
   { name: "Armenia", iso2: "AM", flag: "/flags/AM.png" },
   { name: "Australia", iso2: "AU", flag: "/flags/AU.png" },
   { name: "Austria", iso2: "AT", flag: "/flags/AT.png" },
   { name: "Azerbaijan", iso2: "AZ", flag: "/flags/AZ.png" },
   { name: "Bahamas", iso2: "BS", flag: "/flags/BS.png" },
   { name: "Bahrain", iso2: "BH", flag: "/flags/BH.png" },
   { name: "Bangladesh", iso2: "BD", flag: "/flags/BD.png" },
   { name: "Barbados", iso2: "BB", flag: "/flags/BB.png" },
   { name: "Belarus", iso2: "BY", flag: "/flags/BY.png" },
   { name: "Belgium", iso2: "BE", flag: "/flags/BE.png" },
   { name: "Belize", iso2: "BZ", flag: "/flags/BZ.png" },
   { name: "Benin", iso2: "BJ", flag: "/flags/BJ.png" },
   { name: "Bhutan", iso2: "BT", flag: "/flags/BT.png" },
   { name: "Bolivia", iso2: "BO", flag: "/flags/BO.png" },
  { name: "Bosnia and Herzegovina", iso2: "BA", flag: "/flags/BA.png" },
  { name: "Botswana", iso2: "BW", flag: "/flags/BW.png" },
   { name: "Brazil", iso2: "BR", flag: "/flags/BR.png" },
  // { name: "Brunei", iso2: "BN", flag: "🇧🇳" },
   { name: "Bulgaria", iso2: "BG", flag: "/flags/BG.png" },
   { name: "Burkina Faso", iso2: "BF", flag: "/flags/BF.png" },
  // { name: "Burundi", iso2: "BI", flag: "🇧🇮" },
   { name: "Côte d'Ivoire", iso2: "CI", flag: "/flags/CI.png" },
   { name: "Cook Islands", iso2: "CK", flag: "/flags/CK.png" },
   { name: "Cabo Verde", iso2: "CV", flag: "/flags/CV.png" },
   { name: "Christmas Island", iso2: "CX", flag: "/flags/CX.png" },
   { name: "Cambodia", iso2: "KH", flag: "/flags/KH.png" },
   { name: "Cameroon", iso2: "CM", flag: "/flags/CM.png" },
   { name: "Canada", iso2: "CA", flag: "/flags/CA.png" },
   { name: "Democratic Republic of the Congo", iso2: "CD", flag: "/flags/CD.png" },
   { name: "Central African Republic", iso2: "CF", flag: "/flags/CF.png" },
   { name: "Chad", iso2: "TD", flag: "/flags/TD.png" },
   { name: "East Timor", iso2: "TP", flag: "/flags/TP.png" },
   { name: "Chile", iso2: "CL", flag: "/flags/CL.png" },
   { name: "China", iso2: "CN", flag: "/flags/CN.png" },
   { name: "Colombia", iso2: "CO", flag: "/flags/CO.png" },
   { name: "Comoros", iso2: "KM", flag: "/flags/KM.png" },
   { name: "Congo", iso2: "CG", flag: "/flags/CG.png" },
   { name: "Costa Rica", iso2: "CR", flag: "/flags/CR.png" },
   { name: "Croatia", iso2: "HR", flag: "/flags/HR.png🇭🇷" },
   { name: "Cuba", iso2: "CU", flag: "/flags/CU.png" },
   { name: "Cyprus", iso2: "CY", flag: "/flags/CY.png" },
   { name: "Czech Republic", iso2: "CZ", flag: "/flags/CZ.png" },
   { name: "Denmark", iso2: "DK", flag: "/flags/DK.png" },
   { name: "Djibouti", iso2: "DJ", flag: "/flags/DJ.png" },
   { name: "Dominica", iso2: "DM", flag: "/flags/DM.png" },
   { name: "Dominican Republic", iso2: "DO", flag: "/flags/DO.png" },
   { name: "Ecuador", iso2: "EC", flag: "/flags/EC.png" },
   { name: "Egypt", iso2: "EG", flag: "/flags/EG.png" },
   { name: "El Salvador", iso2: "SV", flag: "/flags/SV.png" },
   { name: "Equatorial Guinea", iso2: "GQ", flag: "/flags/GQ.png" },
   { name: "Eritrea", iso2: "ER", flag: "/flags/ER.png" },
   { name: "Estonia", iso2: "EE", flag: "/flags/EE.png" },
  // { name: "Eswatini", iso2: "SZ", flag: "🇸🇿" },
   { name: "Ethiopia", iso2: "ET", flag: "/flags/ET.png" },
   { name: "Fiji", iso2: "FJ", flag: "/flags/FJ.png" },
   { name: "Falkland Islands (Malvinas)", iso2: "FK", flag: "/flags/FK.png" },
   { name: "Finland", iso2: "FI", flag: "/flags/FI.png" },
   { name: "Faroe Islands", iso2: "FO", flag: "/flags/FO.png" },
   { name: "France", iso2: "FR", flag: "/flags/FR.png" },
   { name: "Gabon", iso2: "GA", flag: "/flags/GA.png" },
   { name: "Gambia", iso2: "GM", flag: "/flags/GM.png" },
   { name: "Georgia", iso2: "GE", flag: "/flags/GE.png" },
   { name: "Germany", iso2: "DE", flag: "/flags/DE.png" },
   { name: "Ghana", iso2: "GH", flag: "/flags/GH.png" },
   { name: "Gibraltar", iso2: "GI", flag: "/flags/GI.png" },
   { name: "Guernsey", iso2: "GK", flag: "/flags/GK.png" },
   { name: "Greenland", iso2: "GL", flag: "/flags/GL.png" },
   { name: "Greece", iso2: "GR", flag: "/flags/GR.png" },
   { name: "Grenada", iso2: "GD", flag: "/flags/GD.png" },
   { name: "Guatemala", iso2: "GT", flag: "/flags/GT.png" },
   { name: "Guinea", iso2: "GN", flag: "/flags/GN.png" },
   { name: "Guinea-Bissau", iso2: "GW", flag: "/flags/GW.png" },
   { name: "Guyana", iso2: "GY", flag: "/flags/GY.png" },
   { name: "Haiti", iso2: "HT", flag: "/flags/HT.png" },
   { name: "Honduras", iso2: "HN", flag: "/flags/HN.png" },
   { name: "Hong Kong", iso2: "HK", flag: "/flags/HK.png" },
   { name: "Hungary", iso2: "HU", flag: "/flags/HU.png" },
   { name: "Iceland", iso2: "IS", flag: "/flags/IS.png" },
  { name: "India", iso2: "IN", flag: "/flags/IN.png" },
   { name: "Indonesia", iso2: "ID", flag: "/flags/ID.png" },
   { name: "Iran", iso2: "IR", flag: "/flags/IR.png" },
   { name: "Iraq", iso2: "IQ", flag: "/flags/IQ.png" },
   { name: "Ireland", iso2: "IE", flag: "/flags/IE.png" },
   { name: "Israel", iso2: "IL", flag: "/flags/IL.png" },
   { name: "Isle of Man", iso2: "IM", flag: "/flags/IM.png" },
   { name: "Italy", iso2: "IT", flag: "/flags/IT.png" },
   { name: "Jersey", iso2: "JE", flag: "/flags/JE.png" },
  // { name: "Jamaica", iso2: "JM", flag: "🇯🇲" },
  // { name: "Japan", iso2: "JP", flag: "🇯🇵" },
   { name: "Jordan", iso2: "JO", flag: "/flags/JO.png" },
   { name: "Kazakhstan", iso2: "KZ", flag: "/flags/KZ.png" },
   { name: "Kenya", iso2: "KE", flag: "/flags/KE.png" },
   { name: "Kiribati", iso2: "KI", flag: "/flags/KI.png" },
   { name: "Kuwait", iso2: "KW", flag: "/flags/KW.png" },
   { name: "Kyrgyzstan", iso2: "KG", flag: "/flags/KG.png" },
   { name: "Laos", iso2: "LA", flag: "/flags/LA.png" },
   { name: "Latvia", iso2: "LV", flag: "/flags/LV.png" },
   { name: "Lebanon", iso2: "LB", flag: "/flags/LB.png" },
   { name: "Lesotho", iso2: "LS", flag: "/flags/LS.png" },
   { name: "Liberia", iso2: "LR", flag: "/flags/LR.png" },
   { name: "Libya", iso2: "LY", flag: "/flags/LY.png" },
   { name: "Liechtenstein", iso2: "LI", flag: "/flags/LI.png" },
   { name: "Lithuania", iso2: "LT", flag: "/flags/LT.png" },
   { name: "Luxembourg", iso2: "LU", flag: "/flags/LU.png" },
   { name: "Madagascar", iso2: "MG", flag: "/flags/MG.png" },
   { name: "Malawi", iso2: "MW", flag: "/flags/MW.png" },
   { name: "Malaysia", iso2: "MY", flag: "/flags/MY.png" },
   { name: "Maldives", iso2: "MV", flag: "/flags/MV.png" },
   { name: "Mali", iso2: "ML", flag: "/flags/ML.png" },
   { name: "Malta", iso2: "MT", flag: "/flags/MT.png" },
   { name: "Marshall Islands", iso2: "MH", flag: "/flags/MH.png" },
   { name: "Mauritania", iso2: "MR", flag: "/flags/MR.png" },
   { name: "Mauritius", iso2: "MU", flag: "/flags/MU.png" },
   { name: "Mexico", iso2: "MX", flag: "/flags/MX.png" },
   { name: "Micronesia", iso2: "FM", flag: "/flags/FM.png" },
  // { name: "Moldova", iso2: "MD", flag: "🇲🇩" },
  // { name: "Monaco", iso2: "MC", flag: "🇲🇨" },
   { name: "Mongolia", iso2: "MN", flag: "/flags/MN.png" },
   { name: "Montenegro", iso2: "ME", flag: "/flags/ME.png" },
   { name: "Morocco", iso2: "MA", flag: "/flags/MA.png" },
   { name: "Mozambique", iso2: "MZ", flag: "/flags/MZ.png" },
  // { name: "Myanmar", iso2: "MM", flag: "🇲🇲" },
   { name: "Namibia", iso2: "NA", flag: "/flags/NA.png" },
  // { name: "Nauru", iso2: "NR", flag: "🇳🇷" },
  // { name: "Nepal", iso2: "NP", flag: "🇳🇵" },
   { name: "Netherlands", iso2: "NL", flag: "/flags/NL.png" },
  // { name: "New Zealand", iso2: "NZ", flag: "🇳🇿" },
   { name: "Nicaragua", iso2: "NI", flag: "/flags/NI.png" },
   { name: "Niger", iso2: "NE", flag: "/flags/NE.png" },
   { name: "Niue", iso2: "NU", flag: "/flags/NU.png" },
  // { name: "Nigeria", iso2: "NG", flag: "🇳🇬" },
   { name: "North Korea", iso2: "KP", flag: "/flags/KP.png" },
  // { name: "North Macedonia", iso2: "MK", flag: "🇲🇰" },
   { name: "Norway", iso2: "NO", flag: "/flags/NO.png" },
  // { name: "Oman", iso2: "OM", flag: "🇴🇲" },
   { name: "Pakistan", iso2: "PK", flag: "/flags/PK.png" },
   { name: "Puerto Rico", iso2: "PR", flag: "/flags/PR.png" },
   { name: "Palestine", iso2: "PS", flag: "/flags/PS.png" },
   { name: "Palau", iso2: "PW", flag: "/flags/PW.png" },
   { name: "Panama", iso2: "PA", flag: "/flags/PA.png" },
  // { name: "Papua New Guinea", iso2: "PG", flag: "🇵🇬" },
   { name: "Paraguay", iso2: "PY", flag: "/flags/PY.png" },
   { name: "Peru", iso2: "PE", flag: "/flags/PE.png" },
   { name: "Philippines", iso2: "PH", flag: "/flags/PH.png" },
  // { name: "Poland", iso2: "PL", flag: "🇵🇱" },
  // { name: "Portugal", iso2: "PT", flag: "🇵🇹" },
   { name: "Qatar", iso2: "QA", flag: "/flags/QA.png" },
   { name: "Romania", iso2: "RO", flag: "/flags/RO.png" },
   { name: "Russia", iso2: "RU", flag: "/flags/RU.png" },
  // { name: "Rwanda", iso2: "RW", flag: "🇷🇼" },
  // { name: "Saint Kitts and Nevis", iso2: "KN", flag: "🇰🇳" },
  // { name: "Saint Lucia", iso2: "LC", flag: "🇱🇨" },
  // { name: "Saint Vincent and the Grenadines", iso2: "VC", flag: "🇻🇨" },
  // { name: "Samoa", iso2: "WS", flag: "🇼🇸" },
  // { name: "San Marino", iso2: "SM", flag: "🇸🇲" },
  // { name: "Sao Tome and Principe", iso2: "ST", flag: "🇸🇹" },
   { name: "Saudi Arabia", iso2: "SA", flag: "/flags/SA.png" },
  // { name: "Senegal", iso2: "SN", flag: "🇸🇳" },
  // { name: "Serbia", iso2: "RS", flag: "🇷🇸" },
  // { name: "Seychelles", iso2: "SC", flag: "🇸🇨" },
  // { name: "Sierra Leone", iso2: "SL", flag: "🇸🇱" },
   { name: "Singapore", iso2: "SG", flag: "/flags/SG.png" },
  // { name: "Slovakia", iso2: "SK", flag: "🇸🇰" },
  // { name: "Slovenia", iso2: "SI", flag: "🇸🇮" },
  // { name: "Solomon Islands", iso2: "SB", flag: "🇸🇧" },
  // { name: "Somalia", iso2: "SO", flag: "🇸🇴" },
  // { name: "South Africa", iso2: "ZA", flag: "🇿🇦" },
   { name: "South Korea", iso2: "KR", flag: "/flags/KR.png" },
  // { name: "South Sudan", iso2: "SS", flag: "🇸🇸" },
  // { name: "Spain", iso2: "ES", flag: "🇪🇸" },
  // { name: "Sri Lanka", iso2: "LK", flag: "🇱🇰" },
   { name: "Sudan", iso2: "SD", flag: "/flags/SD.png" },
  // { name: "Suriname", iso2: "SR", flag: "🇸🇷" },
  // { name: "Sweden", iso2: "SE", flag: "🇸🇪" },
  // { name: "Switzerland", iso2: "CH", flag: "🇨🇭" },
  // { name: "Syria", iso2: "SY", flag: "🇸🇾" },
  // { name: "Taiwan", iso2: "TW", flag: "🇹🇼" },
  // { name: "Tajikistan", iso2: "TJ", flag: "🇹🇯" },
  // { name: "Tanzania", iso2: "TZ", flag: "🇹🇿" },
  // { name: "Thailand", iso2: "TH", flag: "🇹🇭" },
  // { name: "Timor-Leste", iso2: "TL", flag: "🇹🇱" },
  // { name: "Togo", iso2: "TG", flag: "🇹🇬" },
  // { name: "Tonga", iso2: "TO", flag: "🇹🇴" },
  // { name: "Trinidad and Tobago", iso2: "TT", flag: "🇹🇹" },
  // { name: "Tunisia", iso2: "TN", flag: "🇹🇳" },
  // { name: "Turkey", iso2: "TR", flag: "🇹🇷" },
  // { name: "Turkmenistan", iso2: "TM", flag: "🇹🇲" },
  // { name: "Tuvalu", iso2: "TV", flag: "🇹🇻" },
  // { name: "Uganda", iso2: "UG", flag: "🇺🇬" },
  // { name: "Ukraine", iso2: "UA", flag: "🇺🇦" },
  // { name: "United Arab Emirates", iso2: "AE", flag: "🇦🇪" },
  // { name: "United Kingdom", iso2: "GB", flag: "🇬🇧" },
  { name: "United States", iso2: "US", flag: "/flags/US.png" },
   { name: "Uruguay", iso2: "UY", flag: "/flags/UY.png" },
   { name: "Kosovo", iso2: "XK", flag: "/flags/XK.png" },
  // { name: "Uzbekistan", iso2: "UZ", flag: "🇺🇿" },
  // { name: "Vanuatu", iso2: "VU", flag: "🇻🇺" },
  // { name: "Vatican City", iso2: "VA", flag: "🇻🇦" },
  // { name: "Venezuela", iso2: "VE", flag: "🇻🇪" },
  // { name: "Vietnam", iso2: "VN", flag: "🇻🇳" },
  // { name: "Yemen", iso2: "YE", flag: "🇾🇪" },
  // { name: "Zambia", iso2: "ZM", flag: "🇿🇲" },
   { name: "Zimbabwe", iso2: "ZW", flag: "/flags/ZW.png" },
];
